






import { Component, Vue } from "vue-property-decorator";
import UploadForm from "@/components/UploadForm.vue"; // @ is an alias to /src

@Component({
  components: {
    UploadForm
  }
})
export default class Upload extends Vue {}
